<script setup lang="ts">
import { shallowRef } from 'vue';
import MarketplaceOrderDetailsCard from '@/modules/marketplace/components/MarketplaceOrderDetailsCard.vue';
import LoanDetailsDialog from '@/modules/open-loans/components/LoanDetailsDialog.vue';

withDefaults(defineProps<{ orderRef: string; asBroker?: boolean; shouldRetryFetch?: boolean }>(), {
  asBroker: false,
  shouldRetryFetch: false,
});

const emit = defineEmits<{ (e: 'close-modal') }>();

const detailLoanId = shallowRef<string | null>(null);

function closeDialog(): void {
  emit('close-modal');
}
</script>

<template>
  <div>
    <LoanDetailsDialog
      v-if="detailLoanId"
      :as-broker="asBroker"
      :loan-id="detailLoanId"
      @close-modal="detailLoanId = null"
    />
    <VDialog
      v-shortkey="['esc']"
      content-class="au-popup-dialog"
      max-width="1400"
      overlay-color="secondary"
      overlay-opacity="0.80"
      persistent
      scrollable
      :value="true"
      @click:outside="closeDialog()"
      @keydown.esc="closeDialog()"
      @shortkey.native="closeDialog()"
    >
      <MarketplaceOrderDetailsCard
        :as-broker="asBroker"
        :order-ref="orderRef"
        :should-retry-fetch="shouldRetryFetch"
        style="height: 40vh"
        v-on="$listeners"
        @open-loan-details="detailLoanId = $event"
      />
      <VBtn class="close-icon" icon @click="closeDialog()">
        <VIcon>mdi-close</VIcon>
      </VBtn>
    </VDialog>
  </div>
</template>

<style lang="scss" scoped>
.close-icon {
  top: 0.4rem;
  right: 0.4rem;
  position: absolute;
}

::v-deep {
  .v-card {
    min-height: 16vh;
  }
}
</style>
